import axios from "axios"

// 封装axios.get方法
function getRequest(url, params, callback) {
  axios({
    method: "get",
    url: url,
    header: {
      "Content-Type": "application/json; charset=utf-8"
    },
    params: params,
    timeout: 10000
  }).then((response) => {
    let result = response.data;

    if (result.Tag == 1) {
      if (callback) {
        callback(result);
      }
    }
  }).catch((error) => {
    console.log(error);
  })
}

// 封装axios.post方法
function postRequest(url, data, params, callback) {
  axios({
    method: "post",
    url: url,
    header: {
      "Content-Type": "application/json; charset=utf-8"
    },
    params: params,
    data: data,
    timeout: 10000
  }).then((response) => {
    let result = response.data;
  }).catch((error) => {
    console.log(error)
  })
}

export default {
  getRequest: getRequest,
  postRequest: postRequest
}



// WEBPACK FOOTER //
// ./src/api/request.js